import { useSelector } from 'react-redux';

import Global from '../../store/global-selectors';
import { usePlanInfoDerivedSubscriptionInfo } from '../../pages/settings/payment-and-subscription/hooks/use-derive-subscription-info';
import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';
import { useAddOnsFeatureGate } from '../../feature-gates/use-addons-feature-gate';
import { UserPermissionService } from '../../services/user-permission-service';

export const useEnableAddOnCentral = () => {
  const userRoles = useSelector(Global.selectUseruserRoles);
  const userRolePermission = UserPermissionService.userHasConfigurationRole(userRoles);
  const { isCTPPlan } = usePlanInfoDerivedSubscriptionInfo();
  const { isAddOnsFeatureEnabled } = useAddOnsFeatureGate();

  const isAddOnCentralEnabled = useFeatureFlag(FeatureFlagDeclarations.enableAddOnCentral);
  return isAddOnCentralEnabled && !isCTPPlan && userRolePermission && isAddOnsFeatureEnabled;
};
